import VerticalCaret from "./vertical-caret";
export default VerticalCaret;